import { Box, Tab, Tabs, Typography } from '@mui/material'
import React from 'react'
import ComplaintTracking from './ComplaintTracking';
import NewComplaint from './NewComplaint';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}



function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}



const Complaint = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box bgcolor={"#000"}>
      <Tabs value={value} sx={{color:"#fff"}} textColor="primary" variant='fullWidth' onChange={handleChange} aria-label="basic tabs example">
        <Tab sx={{color:'white'}} label="ثبت شکایت" {...a11yProps(0)} />
        <Tab sx={{color:'white'}} label="پیگیری شکایت" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={1}>
        <ComplaintTracking/>
      </TabPanel>
      <TabPanel value={value} index={0}>
        <NewComplaint/>
      </TabPanel>
    </Box>
  )
}

export default Complaint